import React, { useEffect, useState } from 'react';
// tslint:disable-next-line:no-submodule-imports
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import store from 'component/core/store';
import Routes from 'route/index';
import { auth } from 'component/api/auth';
import { userInfo } from 'component/api/user';
import { set } from 'component/user/actions';
import Loader from 'component/loader';

const App = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAuth = async () => {
            const accessToken = auth.getAccess();

            if (accessToken) {
                try {
                    const payload = await userInfo();
                    store.dispatch(set({ id: payload.user_id, username: 'user' }));
                } catch (e) {
                    console.warn('Auth check failed', e);
                    auth.clear();
                }
            }

            setLoading(false);
        };

        checkAuth().then();
    }, []);

    if (loading) {
        return (
            <div style={{display: 'flex', flex: 1, height: '100vh', justifyContent: 'center', alignItems: 'center'}}>
                <Loader text={'Инициализация...'} />
            </div>
        );
    }

    return (
        <Provider store={store}>
            <Routes />
        </Provider>
    );
};

const container = document.getElementById('app');
if (!container) { throw new Error('Root element not found'); }

const root = createRoot(container);
root.render(<App />);
